(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('NotificationsController', NotificationsController);

    /**
     * {function} panelRef.onScaled - called when panel is being scaled ergo on mobile
     * {function} panelRef.onHide - called when back button is pressed (can only happen when scaled ergo on mobile)
     *
     * @param {Object} $animate
     * @param {Object} $mdDialog
     * @param {Object} $mdMedia
     * @param {Object} $mdSidenav
     * @param {Object} $rootScope
     * @param {Object} $scope
     * @param {Object} $state
     * @param {Object} $window
     * @param {Object} $transitions
     * @param {Object} notificationsService
     * @param {Object} bulkService
     * @param {Object} model
     * @param {Object} $timeout
     * @param {Object} usersettings
     * @param {Object} favicoService
     * @param {Object} sfSetupPanel
     * @param {Object} $translate
     */
    function NotificationsController($animate, $mdDialog, $mdMedia, $mdSidenav, $rootScope, $scope, $state, $window, $transitions, notificationsService, bulkService, model, $timeout, usersettings, favicoService, sfSetupPanel, $translate) {

        const vm = this;

        vm.$mdMedia = $mdMedia;
        vm.doneLoading = false;
        vm.isTouchEnabled = $window.touch;

        const emailCreditNotificationTypes = new Set([
            'email_credits_depleted',
            'bulk_find_email_done',
            'bulk_find_email_no_credits_left',
            'bulk_find_email_failed'
        ]);

        init();

        const notificationTitleTranslation = {
            'Email search partially failed': () => $translate.instant('Email search partially failed'),
            'Email search stopped': () => $translate.instant('Email search stopped'),
            'AI personalization complete': () => $translate.instant('AI personalization complete'),
            'No lead credits left': () => $translate.instant('No lead credits left'),
            'Email search done': () => $translate.instant('Email search done'),
            'Bulk account creation done': () => $translate.instant('Bulk account creation done'),
            'Bulk opportunity creation done': () => $translate.instant('Bulk opportunity creation done'),
            'Configured the pipeline': () => $translate.instant('Configured the pipeline'),
            'Tasks': () => $translate.instant('Tasks'),
            'You got a Salesflare upgrade': () => $translate.instant('You got a Salesflare upgrade'),
            'Your plan was downgraded': () => $translate.instant('Your plan was downgraded'),
            'Started a Salesflare trial': () => $translate.instant('Started a Salesflare trial'),
            'Installed the email sidebar': () => $translate.instant('Installed the email sidebar'),
            'Connected the calendar': () => $translate.instant('Connected the calendar'),
            'Created 5 accounts with contacts': () => $translate.instant('Created 5 accounts with contacts'),
            'Installed the mobile app': () => $translate.instant('Installed the mobile app'),
            'Invited teammates': () => $translate.instant('Invited teammates'),
            'Created custom fields': () => $translate.instant('Created custom fields'),
            'Imported data': () => $translate.instant('Imported data'),
            'Sent a first email workflow': () => $translate.instant('Sent a first email workflow'),
            'Set up the first integration': () => $translate.instant('Set up the first integration'),
            'Subscribed to Salesflare': () => $translate.instant('Subscribed to Salesflare'),
            'More lead credits!': () => $translate.instant('More lead credits!'),
            '{{account}} + {{count}} others': (params) => $translate.instant('{{account}} + {{count}} others', params)
        };

        vm.getNotificationTitleTranslation = (notification) => {
            if (!notification.titleTranslation) {
                if (notificationTitleTranslation[notification.title]) {
                    return notificationTitleTranslation[notification.title]();
                }

                return notification.title;
            }

            if (notificationTitleTranslation[notification.titleTranslation]) {
                return notificationTitleTranslation[notification.titleTranslation](notification.titleTranslationParams);
            }

            return notification.title;
        };

        const notificationBodyTranslation = {
            '\uD83D\uDD75\uFE0F An error occurred. Please contact support': () => $translate.instant('\uD83D\uDD75\uFE0F An error occurred. Please contact support'),
            '\uD83D\uDD75\uFE0F No email credits left. Buy more, then retry.': () => $translate.instant('\uD83D\uDD75\uFE0F No email credits left. Buy more, then retry.'),
            'To keep searching, upgrade plan or buy more.': () => $translate.instant('To keep searching, upgrade plan or buy more.'),
            '\uD83D\uDD75\uFE0F No email addresses found.': () => $translate.instant('\uD83D\uDD75\uFE0F No email addresses found.'),
            '\u2728 1 email address found!': () => $translate.instant('\u2728 1 email address found!'),
            '\u2728 {{count}} email addresses found!': (params) => $translate.instant('\u2728 {{count}} email addresses found!', params),
            '\uD83E\uDE84 Your AI personalization is ready. Check it out!': () => $translate.instant('\uD83E\uDE84 Your AI personalization is ready. Check it out!'),
            '\uD83D\uDD75\uFE0F To keep searching, upgrade plan or buy more.': () => $translate.instant('\uD83D\uDD75\uFE0F To keep searching, upgrade plan or buy more.'),
            'You\'ve unlocked the full trial': () => $translate.instant('You\'ve unlocked the full trial'),
            '\u2705 {{name}} assigned you to {{description}}': (params) => $translate.instant('\u2705 {{name}} assigned you to {{description}}', params),
            '\uD83C\uDF89 {{user}} unlocked {{days}} days for the team': (params) => $translate.instant('\uD83C\uDF89 {{user}} unlocked {{days}} days for the team', params),
            '\uD83C\uDF89 {{user}} unlocked {{day}} day for the team': (params) => $translate.instant('\uD83C\uDF89 {{user}} unlocked {{day}} day for the team', params),
            '\uD83D\uDC40 Someone opened {{subject}}': (params) => $translate.instant('\uD83D\uDC40 Someone opened {{subject}}', params),
            '\uD83D\uDC64 {{user}} assigned you to {{task}}': (params) => $translate.instant('\uD83D\uDC64 {{user}} assigned you to {{task}}', params),
            '\uD83D\uDC64 {{user}} assigned you to an opportunity related to {{account}}': (params) => $translate.instant('\uD83D\uDC64 {{user}} assigned you to an opportunity related to {{account}}', params),
            '\uD83D\uDC65 {{user}} joined the team': (params) => $translate.instant('\uD83D\uDC65 {{user}} joined the team', params),
            '\uD83D\uDC65 {{user}} added you to the team': (params) => $translate.instant('\uD83D\uDC65 {{user}} added you to the team', params),
            '\uD83D\uDC65 {{user}} added you to all teams': (params) => $translate.instant('\uD83D\uDC65 {{user}} added you to all teams', params),
            '\uD83D\uDC65 {{user}} left the team': (params) => $translate.instant('\uD83D\uDC65 {{user}} left the team', params),
            '\uD83D\uDC65 {{user}} removed you from the team': (params) => $translate.instant('\uD83D\uDC65 {{user}} removed you from the team', params),
            '\uD83D\uDC65 {{user}} removed you from all teams': (params) => $translate.instant('\uD83D\uDC65 {{user}} removed you from all teams', params),
            '\uD83C\uDFC6 Opportunity {{opportunity}} is won by {{user}}': (params) => $translate.instant('\uD83C\uDFC6 Opportunity {{opportunity}} is won by {{user}}', params),
            '\uD83C\uDFC6 An opportunity from {{account}} is won by {{user}}': (params) => $translate.instant('\uD83C\uDFC6 An opportunity from {{account}} is won by {{user}}', params),
            '\uD83D\uDEAB Opportunity {{opportunity}} was lost': (params) => $translate.instant('\uD83D\uDEAB Opportunity {{opportunity}} was lost', params),
            '\uD83D\uDEAB An opportunity from {{account}} was lost': (params) => $translate.instant('\uD83D\uDEAB An opportunity from {{account}} was lost', params),
            '\uD83D\uDD14 Opportunity {{opportunity}} changed stage to {{stage}} in pipeline {{pipeline}}': (params) => $translate.instant('\uD83D\uDD14 Opportunity {{opportunity}} changed stage to {{stage}} in pipeline {{pipeline}}', params),
            '\uD83D\uDD14 Opportunity {{opportunity}} changed stage to {{stage}}': (params) => $translate.instant('\uD83D\uDD14 Opportunity {{opportunity}} changed stage to {{stage}}', params),
            '\uD83D\uDD14 An opportunity from {{account}} changed stage to {{stage}} in pipeline {{pipeline}}': (params) => $translate.instant('\uD83D\uDD14 An opportunity from {{account}} changed stage to {{stage}} in pipeline {{pipeline}}', params),
            '\uD83D\uDD14 An opportunity from {{account}} changed stage to {{stage}}': (params) => $translate.instant('\uD83D\uDD14 An opportunity from {{account}} changed stage to {{stage}}', params),
            '\uD83D\uDCC6 Prepare your meeting with {{contact}}': (params) => $translate.instant('\uD83D\uDCC6 Prepare your meeting with {{contact}}', params),
            '\uD83D\uDCC6 AI notes synced for your meeting with {{contact}}': (params) => $translate.instant('\uD83D\uDCC6 AI notes synced for your meeting with {{contact}}', params),
            '\u26A1 {{account}} has been inactive for {{days}} days. Time to follow up?': (params) => $translate.instant('\u26A1 {{account}} has been inactive for {{days}} days. Time to follow up?', params),
            '\u2705 {{description}}': (params) => $translate.instant('\u2705 {{description}}', params),
            '\uD83D\uDCC6 Don\'t forget to add notes to your meeting with {{contact}}': (params) => $translate.instant('\uD83D\uDCC6 Don\'t forget to add notes to your meeting with {{contact}}', params),
            '\uD83D\uDD25 {{account}} is now {{hotness}}': (params) => $translate.instant('\uD83D\uDD25 {{account}} is now {{hotness}}', { hotness: $translate.instant(params.hotness) }),
            '{{user}} just upped you to the {{plan}} plan \uD83C\uDF89': (params) => $translate.instant('{{user}} just upped you to the {{plan}} plan \uD83C\uDF89', params),
            'You\'re now on the {{plan}} plan': (params) => $translate.instant('You\'re now on the {{plan}} plan', params),
            '\uD83C\uDF89 {{user}} got the {{package}} credit package.': (params) => $translate.instant('\uD83C\uDF89 {{user}} got the {{package}} credit package.', params),
            '\uD83C\uDF10 {{contact}} visited {{account}} on {{website}}': (params) => $translate.instant('\uD83C\uDF10 {{contact}} visited {{account}} on {{website}}', params),
            '\uD83D\uDD17 Someone visited {{website}}': (params) => $translate.instant('\uD83D\uDD17 Someone visited {{website}}', params),
            '\uD83D\uDD17 {{contact}} visited {{website}}': (params) => $translate.instant('\uD83D\uDD17 {{contact}} visited {{website}}', params),
            '\uD83D\uDCDE {{user}} called with {{contact}}': (params) => $translate.instant('\uD83D\uDCDE {{user}} called with {{contact}}', params),
            '\u2728 Accounts created for {{count}} contacts.': (params) => $translate.instant('\u2728 Accounts created for {{count}} contacts.', params),
            '\u2728 Accounts created for 1 contact.': () => $translate.instant('\u2728 Accounts created for 1 contact.'),
            '\u2728 Opportunities created for {{count}} accounts.': (params) => $translate.instant('\u2728 Opportunities created for {{count}} accounts.', params),
            '\u2728 Opportunities created for 1 account.': () => $translate.instant('\u2728 Opportunities created for 1 account.')
        };

        vm.getNotificationBodyTranslation = (notification) => {
            if (!notification.bodyTranslation) {
                if (notificationBodyTranslation[notification.body]) {
                    return notificationBodyTranslation[notification.body]();
                }

                return notification.body;
            }

            if (notificationBodyTranslation[notification.bodyTranslation]) {
                return notificationBodyTranslation[notification.bodyTranslation](notification.bodyTranslationParams);
            }

            return notification.body;
        };

        vm.notifications = {
            toLoad: 0,
            numLoaded: 0,
            stepAmount: 20,
            items: [],
            topIndex: 0,

            getItemAtIndex: function (index) {

                if (index > this.numLoaded) {
                    this.fetchMoreItems(index);

                    return null;
                }

                return this.items[index];
            },

            getLength: function () {

                if (this.items.length < this.numLoaded) {
                    return this.items.length;
                }

                return this.numLoaded + this.stepAmount;
            },

            fetchMoreItems: function (index) {

                if (this.toLoad < index) {
                    this.toLoad += this.stepAmount;

                    const boundFirstResponseHandler = angular.bind(this, function (response) {

                        this.items = getNotificationsWithSubheader(response.data);
                        this.items.forEach((item) => {

                            item.displayBody = vm.getNotificationBodyTranslation(item);
                            item.displayTitle = vm.getNotificationTitleTranslation(item);
                        });

                        this.numLoaded = this.stepAmount;

                        vm.doneLoading = true;
                    });
                    const boundSecondResponseHandler = angular.bind(this, function (response) {

                        this.items = getNotificationsWithSubheader([...this.items, ...response.data]);

                        this.items.forEach((item) => {

                            item.displayBody = vm.getNotificationBodyTranslation(item);
                            item.displayTitle = vm.getNotificationTitleTranslation(item);
                        });

                        this.numLoaded += this.stepAmount;
                    });

                    const responseHandler = this.items.length === 0 ? boundFirstResponseHandler : boundSecondResponseHandler;

                    return notificationsService.get({ limit: 20, offset: this.numLoaded }).then(responseHandler);
                }
            },

            // Forces reset of object
            reload: function () {

                this.toLoad = 0;
                this.numLoaded = 0;
                this.items = [];
                this.doneLoading = false;
                this.topIndex = 0;
            }
        };

        vm.markAsRead = function (notification) {

            return notificationsService.update(notification.id, { read: !notification.read }).then(function () {

                notification.read = !notification.read;
            });
        };

        vm.getMarkAsText = function (notification) {

            if (!notification) {
                return '';
            }

            const status = notification.read ? $translate.instant('unread') : $translate.instant('read');
            return $translate.instant('Mark as {{status}}', { status });
        };

        vm.delete = function (notificationId) {

            vm.notifications.numLoaded--;

            vm.notifications.items = vm.notifications.items.filter(function (n) {

                return n.id !== notificationId;
            });

            return notificationsService.delete(notificationId);
        };

        vm.markAllAsRead = function () {

            return bulkService.updateNotifications({ filter: { read: false }, update: { read: true } }).then(function () {

                vm.notifications.items.forEach(function (notification) {

                    notification.read = true;
                });
            });
        };

        vm.deleteAll = function () {

            const confirm = $mdDialog.confirm({ multiple: true })
                .clickOutsideToClose(true)
                .textContent($translate.instant('Are you sure you want to clear all notifications?'))
                .ok($translate.instant('Yes'))
                .cancel($translate.instant('No'));

            return $mdDialog.show(confirm).then(function () {

                return bulkService.updateNotifications( { filter: { archived: false }, update: { archived: true } } ).then(function () {

                    vm.notifications.items = [];
                });
            });
        };

        vm.onNotificationClicked = function (notification) {

            notificationsService.update(notification.id, { read: true });

            vm.closePanel();

            if (notification.type === 'setup_step_completed') {
                if ($mdMedia('gt-sm')) {
                    return sfSetupPanel.show();
                }

                return $state.go('setup');
            }
            else if (emailCreditNotificationTypes.has(notification.type)) {
                // On bulk find email completion we want to go to the contacts page
                // For other credit notifications we go to the plans or credits page
                if (notification.type === 'bulk_find_email_done' || notification.type === 'bulk_find_email_failed') {
                    $state.go('contacts.customers');
                    return top.focus();
                }

                const planId = model.me.team.plan;
                const userAmount = model.me.team.enabled_user_count;

                // Go to the plans page if the team is on the Growth plan, or if it's on the Pro plan with 5 or more users
                if (planId === 3 || (planId === 4 && userAmount >= 5)) {
                    $state.go('plans');
                }
                // Otherwise go to the credits page
                else {
                    $state.go('credits');
                }
            }
            else if (notification.account) {
                $state.go('accounts.account.feed', { id: notification.account }, { inherit: false });
            }
            else {
                $state.go('tasks.today');
            }

            return top.focus();
        };

        vm.openMenu = function (mdMenu, event) {

            return mdMenu.open(event);
        };

        vm.toggleMenu = function () {

            return $mdSidenav('menu').toggle();
        };

        vm.closePanel = function () {

            // Using vm.mdPanelRef instead of injected mdPanelRef since controller is both used for component and panel
            if (vm.mdPanelRef) {
                return vm.mdPanelRef.close().then(function () {

                    return vm.mdPanelRef.destroy();
                });
            }
        };

        function getNotificationsWithSubheader(items) {

            const notificationsWithSubheader = [];

            items.forEach(function (item, index) {

                if (index !== 0 && !items[index - 1].earlierSubheader && !items[index - 1].viewed && item.viewed) {
                    notificationsWithSubheader.push({ earlierSubheader: true });
                }

                notificationsWithSubheader.push(item);
            });

            return notificationsWithSubheader;
        }

        function init() {

            favicoService.reset();

            // Notifications are loaded inside a panel on full screen, redirect to /tasks when trying to access /notifications on full screen
            if ($state.is('notifications') && $mdMedia('gt-sm')) {
                return $state.go('tasks.today');
            }

            $scope.$watch(function () {

                return $mdMedia('gt-sm');
            }, function (newValue, oldValue) {

                if (newValue === true && oldValue === false) {
                    return $rootScope.back();
                }
                else if (newValue === false && oldValue === true) {
                    vm.closePanel();
                    return $state.go('notifications');
                }
            });

            if (vm.isTouchEnabled) {
                $timeout(function () {

                    const elementWidth = angular.element('.notification').width() || 200;
                    const trashIconAreaWidth = 20 + (16 * 2);

                    Swiped.init({
                        query: '.notification',
                        right: elementWidth - trashIconAreaWidth,
                        left: elementWidth - trashIconAreaWidth,
                        tolerance: elementWidth * 0.4,
                        onOpen: function () {

                            const swipedElement = this.elem;

                            $scope.$apply(function () {

                                $animate.addClass(swipedElement, 'collapse-list-item').then(function () {

                                    vm.delete(Number(swipedElement.id));
                                    swipedElement.style.cssText = '';
                                    angular.element(swipedElement).removeClass('collapse-list-item');
                                });
                            });
                        }
                    });
                }, 1000);
            }
        }


        if ($state.is('notifications')) {
            const removeStartTransitionHook = $transitions.onStart({}, (transition) => {
                const fromState = transition.from();
                const toState = transition.to();

                if (fromState.name && toState.name && fromState.name === 'notifications' && toState.name !== 'notifications') {
                    removeStartTransitionHook();

                    model.me.amountOfNotViewedNotifications = 0;
                    return usersettings.setLastVisitedNotificationsToNow();
                }
            });
        }
    }
})();
